import axios from "../lib/axios"
import { CREATE_TAG_PROMOTION, DELETE_TAG_PROMOTION, TAG_PROMOTION_FIND_MANY, UPDATE_TAG_PROMOTION } from "../lib/endpoints/promotion"
import { TagPromotionModel } from "../models/tagPromotion.model"

interface CreateTagPromotionInput {
    tagType: string
    tagName: string
    color: string
    image: File | null
}

interface UpdateTagPromotionInput {
    id: string
    tagType: string
    tagName: string
    color: string
    image: File | null
}

export const getAllTagPromotion = async (): Promise<TagPromotionModel[]> => {
    try {
        const res = await axios.get(TAG_PROMOTION_FIND_MANY)
        return res?.data
    } catch (error) {
        throw error
    }
}

export const createTagPromotion = async ({ tagName, tagType, image, color }: CreateTagPromotionInput) => {
    try {
        const formData = new FormData()
        formData.append('tagType', tagType)
        formData.append('tagName', tagName)
        formData.append('color', color)
        if (image) {
            formData.append("image", image)
        }

        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }

        const resData = await axios.post(CREATE_TAG_PROMOTION, formData, config)
        return resData?.data
    } catch (error) {
        throw error
    }
}

export const updateTagPromotion = async ({ id, tagName, tagType, image, color }: UpdateTagPromotionInput) => {
    try {
        const formData = new FormData()
        formData.append('tagType', tagType)
        formData.append('tagName', tagName)
        formData.append('color', color)
        if (image) {
            formData.append("image", image)
        }

        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }

        const resData = await axios.put(`${UPDATE_TAG_PROMOTION}${id}`, formData, config)
        return resData?.data
    } catch (error) {
        throw error
    }
}

export const deleteTagPromotion = async (id: string) => {
    try {
        await axios.delete(`${DELETE_TAG_PROMOTION}${id}`)
    } catch (error) { throw error }
}